export default __webpack_public_path__ + "static/gvh-logo-aa26ca4ea0e698613b582f17b235aecb.svg";